import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "main-container"
};
const _hoisted_2 = {
  class: "filter-container",
  style: {
    "margin-bottom": "0"
  }
};
const _hoisted_3 = {
  class: "table-container"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 3
};
const _hoisted_8 = {
  key: 4
};
const _hoisted_9 = {
  style: {
    "max-width": "150px",
    "word-break": "break-all"
  }
};
const _hoisted_10 = {
  style: {
    "max-width": "150px",
    "word-break": "break-all"
  }
};
const _hoisted_11 = {
  class: "dialog-footer"
};
import { reactive, getCurrentInstance, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/store/index';
import { getOfflineRecordsListApi, offlineRecordsEditApi, offlineRecordsDetailApi, pushOrderApi } from '@/apis/order';
import { getBrandListApi } from '@/apis/brand';
import Pagination from '@/components/Pagination.vue';
import Keys from '@/constant/key';
import { joinParams } from '@/utils/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'OfflineList',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const userGroups = store.state.user.userInfo.group_id.split(',');
    const searchForm = reactive({
      order_type: '',
      brand_id: '',
      channel: '',
      push_status: '',
      goods_name: '',
      create_time: ''
    });
    const state = reactive({
      orderList: [],
      brandList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    });
    // 编辑弹窗相关
    const editDialogVisible = ref(false);
    const editFormRef = ref();
    const editForm = reactive({
      id: '',
      re_order: '',
      create_time: '',
      channel: '',
      channel_list: [],
      gg_id: '',
      order_type: '',
      num: '',
      price: '',
      ship_price: '',
      channel_price: '',
      shop_price: '',
      other_fee: '',
      buyer_phone: '',
      buyer_name: '',
      city_name: '',
      area: '',
      address: '',
      ship_type: '',
      shop_id: 0,
      ship_date: '',
      ship_time_test: '',
      remark: ''
    });
    // 批量添加
    const addDialog = ref(false);
    const fileList = ref([]);
    const addFormRef = ref();
    const addForm = reactive({
      file: null
    });
    const getList = () => {
      getOfflineRecordsListApi({
        ...searchForm,
        page: state.currentPage,
        page_size: state.pageSize
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.orderList = data.data;
        state.total = data.pagination.total;
      });
    };
    const getBrandList = async () => {
      const {
        code,
        data,
        msg
      } = await getBrandListApi({
        if_body: 2
      });
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      state.brandList = data;
    };
    const handleSearch = () => {
      state.currentPage = 1;
      getList();
    };
    const handleSizeChange = val => {
      state.pageSize = val;
      getList();
    };
    const handleCurrentChange = val => {
      state.currentPage = val;
      getList();
    };
    const handleBatchAdd = () => {
      addDialog.value = true;
    };
    const onUploadSuccess = res => {
      const {
        code,
        data,
        msg
      } = res;
      if (code == 200) {
        proxy.$message({
          type: 'success',
          message: msg
        });
        addDialogClose();
      } else {
        proxy.$confirm(`${msg}`, '提示', {
          type: 'error',
          showCancelButton: false,
          confirmButtonText: '清除文件',
          closeOnClickModal: false // 禁止点击空白处关闭弹窗
        }).then(() => {
          proxy.$refs.uploadRef.clearFiles();
          fileList.value = [];
        }).catch(() => {
          proxy.$refs.uploadRef.clearFiles();
          fileList.value = [];
          console.log('取消操作');
        });
      }
    };
    const dialogSubmit = () => {
      proxy.$refs.uploadRef.submit();
      getList();
    };
    const addDialogClose = () => {
      proxy.$refs.uploadRef.clearFiles();
      fileList.value = [];
      addDialog.value = false;
    };
    const handleExport = () => {
      window.open(`${Keys.baseUrl}/opsapi/offline_export?${joinParams({
        ...searchForm
      })}&export=1&Access_token=${store.state.user.userInfo.access_token}`);
    };
    const handleEdit = row => {
      const {
        id
      } = row;
      offlineRecordsDetailApi({
        id
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        Object.assign(editForm, {
          id: data.id || '',
          re_order: data.re_order || '',
          create_time: data.create_time || '',
          channel: data.channel || '',
          channel_list: data.channel_list || [],
          gg_id: data.gg_id || '',
          order_type: data.order_type || '',
          num: data.num || '',
          price: data.price || '',
          ship_price: data.ship_price || '',
          channel_price: data.channel_price || '',
          shop_price: data.shop_price || '',
          other_fee: data.other_fee || '',
          buyer_phone: data.buyer_phone || '',
          buyer_name: data.buyer_name || '',
          city_name: data.city_name || '',
          area: data.area || '',
          address: data.address || '',
          ship_type: data.ship_type || '',
          shop_id: data.shop_id || '',
          ship_date: data.ship_date || '',
          ship_time_test: data.ship_time_test || '',
          remark: data.remark || ''
        });
        editDialogVisible.value = true;
      });
    };
    // 保存编辑
    const handleSave = () => {
      var _editFormRef$value;
      (_editFormRef$value = editFormRef.value) === null || _editFormRef$value === void 0 || _editFormRef$value.validate(valid => {
        if (valid) {
          offlineRecordsEditApi(editForm).then(res => {
            const {
              code,
              msg
            } = res;
            if (code == 200) {
              proxy.$message({
                type: 'success',
                message: '保存成功'
              });
              editDialogVisible.value = false;
              getList();
            } else {
              proxy.$message({
                type: 'error',
                message: msg
              });
            }
          });
        }
      });
    };
    const handleFileChange = (file, fileList) => {
      fileList.value = fileList; // 更新文件列表
    };
    // 推送
    const handlePush = (row, tpe) => {
      const {
        id
      } = row;
      pushOrderApi({
        id,
        type: tpe
      }).then(res => {
        const {
          code,
          msg
        } = res;
        if (code == 200) {
          proxy.$message({
            type: 'success',
            message: '推送成功'
          });
          getList();
        } else {
          proxy.$message({
            type: 'error',
            message: msg
          });
        }
      });
    };
    onMounted(() => {
      getList();
      getBrandList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "",
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.order_type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.order_type = $event),
            placeholder: "类型",
            class: "filter-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "蛋糕",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "零食",
              value: "5"
            }), _createVNode(_component_el_option, {
              label: "鲜花",
              value: "8"
            }), _createVNode(_component_el_option, {
              label: "水果",
              value: "10"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "",
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.brand_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.brand_id = $event),
            placeholder: "品牌",
            class: "filter-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "-全部-",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.brandList, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "",
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.channel,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.channel = $event),
            placeholder: "渠道",
            class: "filter-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "-全部-",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "百联",
              value: "百联"
            }), _createVNode(_component_el_option, {
              label: "沃百富",
              value: "沃百富"
            }), _createVNode(_component_el_option, {
              label: "优佳悦享",
              value: "优佳悦享"
            }), _createVNode(_component_el_option, {
              label: "国美真快乐",
              value: "国美真快乐"
            }), _createVNode(_component_el_option, {
              label: "农行线下",
              value: "农行线下"
            }), _createVNode(_component_el_option, {
              label: "分贝通",
              value: "分贝通"
            }), _createVNode(_component_el_option, {
              label: "中票优品",
              value: "中票优品"
            }), _createVNode(_component_el_option, {
              label: "中航翼购",
              value: "中航翼购"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "",
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.push_status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchForm.push_status = $event),
            placeholder: "推送状态",
            class: "filter-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "未推送",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "已推送",
              value: "1"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: searchForm.goods_name,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => searchForm.goods_name = $event),
            placeholder: "搜索商品名称",
            class: "filter-item"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: searchForm.create_time,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => searchForm.create_time = $event),
            type: "date",
            "value-format": "YYYY-MM-DD",
            placeholder: "下单日期",
            class: "filter-item"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSearch
          }, {
            default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("搜索")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "success",
            onClick: handleExport
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("导出")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleBatchAdd
          }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode("批量添加")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
        data: state.orderList,
        stripe: "",
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "id",
          width: "70"
        }), _createVNode(_component_el_table_column, {
          prop: "re_order",
          label: "关联订单号",
          width: "160"
        }), _createVNode(_component_el_table_column, {
          prop: "create_time",
          label: "订单发生时间",
          width: "160"
        }), _createVNode(_component_el_table_column, {
          prop: "channel",
          label: "渠道",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "brand_id",
          label: "品牌ID",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌名称",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "goods_id",
          label: "商品ID",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "goods_name",
          label: "商品名称",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "gg_id",
          label: "规格ID",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "gg_name",
          label: "规格名称",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "order_type",
          label: "订单类型",
          width: "80"
        }, {
          default: _withCtx(scope => [scope.row.order_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "蛋糕")) : _createCommentVNode("", true), scope.row.order_type == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "零食")) : _createCommentVNode("", true), scope.row.order_type == 8 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "鲜花")) : _createCommentVNode("", true), scope.row.order_type == 10 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "水果")) : _createCommentVNode("", true), scope.row.order_type == 'other' ? (_openBlock(), _createElementBlock("span", _hoisted_8, "其他")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量",
          width: "60"
        }), _createVNode(_component_el_table_column, {
          prop: "price",
          label: "单价",
          width: "70"
        }), _createVNode(_component_el_table_column, {
          prop: "ship_price",
          label: "运费",
          width: "70"
        }), _createVNode(_component_el_table_column, {
          prop: "channel_price",
          label: "渠道结算价",
          width: "90"
        }), _createVNode(_component_el_table_column, {
          prop: "shop_price",
          label: "商家结算价",
          width: "90"
        }), _createVNode(_component_el_table_column, {
          prop: "other_fee",
          label: "另收费用",
          width: "70"
        }), _createVNode(_component_el_table_column, {
          prop: "remark",
          label: "备注",
          width: "150"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_9, _toDisplayString(scope.row.remark), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "address",
          label: "地址",
          width: "150"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_10, _toDisplayString(scope.row.address), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "蛋叔订单号",
          width: "140"
        }), _createVNode(_component_el_table_column, {
          prop: "push_status",
          label: "推送状态",
          width: "80"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.push_status == '1' ? '已推送' : '未推送'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "push_msg",
          label: "推送备注",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "260",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleEdit(scope.row)
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), scope.row.push_status == 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "small",
            onClick: $event => handlePush(scope.row, 1)
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("推送")])),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.push_status === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            size: "small",
            onClick: $event => handlePush(scope.row, 2)
          }, {
            default: _withCtx(() => _cache[35] || (_cache[35] = [_createTextVNode("强行推送")])),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(Pagination, {
        style: {
          "margin-top": "15px"
        },
        currentPage: state.currentPage,
        total: state.total,
        onPageChange: handleCurrentChange,
        onSizeChange: handleSizeChange
      }, null, 8, ["currentPage", "total"]), _createVNode(_component_el_dialog, {
        title: "编辑订单",
        modelValue: _unref(editDialogVisible),
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _isRef(editDialogVisible) ? editDialogVisible.value = $event : null),
        width: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = $event => editDialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave
        }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [_createTextVNode("保存")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: editForm,
          "label-width": "120px",
          ref_key: "editFormRef",
          ref: editFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "关联订单号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.re_order,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => editForm.re_order = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "订单发生时间："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.create_time,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => editForm.create_time = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属渠道："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: editForm.channel,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => editForm.channel = $event),
              placeholder: "请选择渠道",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editForm.channel_list, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: _ctx.index,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "规格ID："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.gg_id,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => editForm.gg_id = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "订单类型："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: editForm.order_type,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => editForm.order_type = $event),
              placeholder: "请选择订单类型",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "蛋糕",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "零食",
                value: 5
              }), _createVNode(_component_el_option, {
                label: "鲜花",
                value: 8
              }), _createVNode(_component_el_option, {
                label: "水果",
                value: 10
              }), _createVNode(_component_el_option, {
                label: "其他",
                value: "other"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "购买数量："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.num,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => editForm.num = $event),
              type: "number"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "出售单价："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.price,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => editForm.price = $event),
              type: "number"
            }, {
              append: _withCtx(() => _cache[36] || (_cache[36] = [_createTextVNode("元")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "运费："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.ship_price,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => editForm.ship_price = $event),
              type: "number"
            }, {
              append: _withCtx(() => _cache[37] || (_cache[37] = [_createTextVNode("元")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "渠道结算价："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.channel_price,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => editForm.channel_price = $event),
              type: "number"
            }, {
              append: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode("元")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商家结算价："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.shop_price,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => editForm.shop_price = $event),
              type: "number"
            }, {
              append: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("元")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "另收费用："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.other_fee,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => editForm.other_fee = $event),
              type: "number"
            }, {
              append: _withCtx(() => _cache[40] || (_cache[40] = [_createTextVNode("元")])),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下单人手机号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.buyer_phone,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => editForm.buyer_phone = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下单人姓名："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.buyer_name,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => editForm.buyer_name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "城市名称（市）："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.city_name,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => editForm.city_name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "区县："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.area,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => editForm.area = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "详细地址："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.address,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => editForm.address = $event),
              type: "textarea",
              rows: 2
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "配送类型："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: editForm.ship_type,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => editForm.ship_type = $event),
              placeholder: "请选择配送类型",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "送货上门",
                value: "delivery"
              }), _createVNode(_component_el_option, {
                label: "上店自取",
                value: "shop"
              }), _createVNode(_component_el_option, {
                label: "快递",
                value: "same"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "门店ID："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.shop_id,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => editForm.shop_id = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "配送日期："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: editForm.ship_date,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => editForm.ship_date = $event),
              type: "date",
              placeholder: "选择日期",
              style: {
                "width": "100%"
              },
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "配送时间："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_time_picker, {
              modelValue: editForm.ship_time_test,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => editForm.ship_time_test = $event),
              placeholder: "选择时间",
              style: {
                "width": "100%"
              },
              "value-format": "HH:mm:ss"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editForm.remark,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => editForm.remark = $event),
              type: "textarea",
              rows: 3
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "批量上传默认餐具",
        modelValue: _unref(addDialog),
        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => _isRef(addDialog) ? addDialog.value = $event : null),
        "before-close": addDialogClose,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: addDialogClose
        }, {
          default: _withCtx(() => _cache[45] || (_cache[45] = [_createTextVNode("取 消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[46] || (_cache[46] = [_createTextVNode("确 定")])),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上传文件"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "upload-demo",
              ref: "uploadRef",
              action: `/api/opsapi/doAddPl?user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}&Access_token=${_unref(store).state.user.userInfo.access_token}`,
              "on-success": onUploadSuccess,
              accept: ".xls,.xlsx",
              "file-list": _unref(fileList),
              "auto-upload": false,
              limit: 1,
              onChange: handleFileChange
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: _unref(fileList).length >= 1
              }, {
                default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("点击上传")])),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }, 8, ["action", "file-list"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_link, {
              href: `${_unref(Keys).baseUrl}/opsapi/downloadExcelPladd?user_id=${_unref(store).state.user.userInfo.id}&Access_token=${_unref(store).state.user.userInfo.access_token}`
            }, {
              default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode("下载批量添加模版")])),
              _: 1
            }, 8, ["href"])]),
            _: 1
          })]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});